export default "/images/account_statement.png?0aca49d4eafd6f8eed9fa7ad8d1cee79";